export default {
    'ERROR-CUSTOMER-0002': 'apiMessage.userAlreadyExist'
}